// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3vE_E","selected":"Chip_selected__1I3on"};